import React, { useEffect, useRef, useState } from "react";
import "./BuiltBySlashEasyFloating.css";

function BuiltBySlashEasyFloating() {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!containerRef.current) {
        return;
      }

      if (!containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const togglePanel = () => {
    setIsOpen((previous) => !previous);
  };

  const closePanel = () => {
    setIsOpen(false);
  };

  return (
    <div className="bse-floating" ref={containerRef}>
      {isOpen && (
        <section
          id="bse-tech-stack-panel"
          className="bse-panel"
          role="dialog"
          aria-label="Tech Stack"
          aria-modal="false"
        >
          <header className="bse-panel-header">
            <div className="bse-panel-title-wrap">
              <span className="bse-panel-code-icon" aria-hidden="true">
                {"</>"}
              </span>
              <h3 className="bse-panel-title">Tech Stack</h3>
            </div>
            <button
              type="button"
              className="bse-icon-close"
              onClick={closePanel}
              aria-label="Close tech stack panel"
            >
              ×
            </button>
          </header>

          <div className="bse-panel-content">
            <div className="bse-stack-group">
              <p className="bse-stack-heading">FRONTEND</p>
              <ul className="bse-stack-list">
                <li>React.js</li>
                <li>Tailwind CSS (or project styling)</li>
                <li>Responsive UI</li>
              </ul>
            </div>

            <div className="bse-stack-group">
              <p className="bse-stack-heading">BACKEND</p>
              <ul className="bse-stack-list">
                <li>Node.js</li>
                <li>Express.js</li>
              </ul>
            </div>

            <div className="bse-stack-group">
              <p className="bse-stack-heading">DATABASE</p>
              <ul className="bse-stack-list">
                <li>MongoDB</li>
              </ul>
            </div>

            <div className="bse-stack-group">
              <p className="bse-stack-heading">AUTHENTICATION</p>
              <ul className="bse-stack-list">
                <li>JWT</li>
                <li>Secure login system</li>
              </ul>
            </div>
          </div>

          <footer className="bse-panel-footer">Built with ❤ by SlashEasy</footer>
        </section>
      )}

      <button
        type="button"
        className="bse-trigger"
        onClick={togglePanel}
        aria-expanded={isOpen}
        aria-controls="bse-tech-stack-panel"
      >
        <span className="bse-trigger-dot" aria-hidden="true" />
        <span>Built by SlashEasy</span>
        <span className="bse-trigger-arrow" aria-hidden="true">
          ▾
        </span>
      </button>
    </div>
  );
}

export default BuiltBySlashEasyFloating;
